import { FlexBox } from '@ardoq/layout';
import { colors, s16 } from '@ardoq/design-tokens';
import styled from 'styled-components';

/**
 * Pass in ButtonGroup with buttons as children
 */
export const PageBodyFooter = styled(FlexBox).attrs({ gap: 'medium' })`
  width: 100%;
  padding: ${s16};
  background-color: ${colors.surfaceDefault};
  border-top: 1px solid ${colors.borderSubtle};
  justify-content: flex-end;
`;
